"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_class_component_1 = require("vue-class-component");
var vue_property_decorator_1 = require("vue-property-decorator");
var qs = require("qs");
var CampaignFactoryProfilingModalComponent = (function (_super) {
    __extends(CampaignFactoryProfilingModalComponent, _super);
    function CampaignFactoryProfilingModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        return _this;
    }
    CampaignFactoryProfilingModalComponent.prototype.data = function () {
        return {
            dialog: this.dialog,
            profilingParameters: []
        };
    };
    CampaignFactoryProfilingModalComponent.prototype.parseProfiling = function () {
        var _this = this;
        this.dialog = true;
        this.profilingParameters = [];
        if (!this.profiling || '' === this.profiling) {
            return;
        }
        var profilingParametersParts = this.profiling.split('&');
        profilingParametersParts.forEach(function (part) {
            var parsedUrl = qs.parse(part, {
                plainObjects: true,
                allowDots: true,
                allowPrototypes: true
            });
            for (var fieldKey in parsedUrl) {
                var fieldValue = parsedUrl[fieldKey];
                _this.profilingParameters.push({
                    key: fieldKey,
                    value: fieldValue
                });
            }
        });
    };
    CampaignFactoryProfilingModalComponent.prototype.generateProfiling = function () {
        var _this = this;
        this.newUrl = '';
        this.profilingParameters.forEach(function (profilingParameter, index) {
            if ('' !== profilingParameter.key) {
                _this.newUrl += profilingParameter.key + "=" + profilingParameter.value.replace(/\s+/g, '+');
                if (index < _this.profilingParameters.length - 1) {
                    _this.newUrl += '&';
                }
            }
        }, this);
        this.$emit('profiling-generated', this.newUrl);
        this.dialog = false;
    };
    CampaignFactoryProfilingModalComponent.prototype.addProfilingParameter = function () {
        this.profilingParameters.push({
            key: '',
            value: ''
        });
    };
    CampaignFactoryProfilingModalComponent.prototype.removeProfilingParameter = function (complexParameterIndex) {
        this.profilingParameters.splice(complexParameterIndex, 1);
    };
    __decorate([
        vue_property_decorator_1.Prop(),
        __metadata("design:type", String)
    ], CampaignFactoryProfilingModalComponent.prototype, "profiling", void 0);
    CampaignFactoryProfilingModalComponent = __decorate([
        vue_class_component_1.default
    ], CampaignFactoryProfilingModalComponent);
    return CampaignFactoryProfilingModalComponent;
}(vue_1.default));
exports.default = CampaignFactoryProfilingModalComponent;
